import React, { useEffect, useRef } from "react";
import {
  SideNav,
  SideNavItems,
  SideNavLink,
  SideNavMenu ,
  SideNavDivider,

} from "@carbon/react";

import { } from "@carbon/react";
import {useUser} from "../../context/UserContext";
import { hasPagePermission } from "../../utils/hasPagePermission";
import { ROUTE_PERMISSIONS } from "../../config/routePermissions";


export default function Sidebar({ isExpanded, onClose }) {
  
  const { permissions, user } = useUser();

    const sidebarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isExpanded &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isExpanded, onClose]);


    
return (
  <div ref={sidebarRef}>
    <SideNav
      className="sidenav"
      expanded={isExpanded}
      aria-label="Side navigation"
      isFixedNav
      isChildOfHeader={true}
      isPersistent
      isRail={!isExpanded}
    >
      
        <SideNavItems>
           {hasPagePermission(permissions,ROUTE_PERMISSIONS["dashboard"]) && 
          <>
          <SideNavLink href="/dashboard" onClick={onClose}>
            Dashboard
          </SideNavLink>
           </>
          }
          <SideNavDivider />
{hasPagePermission(
  permissions,
  ROUTE_PERMISSIONS["settings/property-management"]
) && (
  <>
    <SideNavMenu title="Property Management">

      <SideNavLink
        href="/settings/builder-management"
        onClick={onClose}
      >
        Builder Management
      </SideNavLink>

      <SideNavLink
        href="/settings/property-management"
        onClick={onClose}
      >
        Property Management
      </SideNavLink>

      {hasPagePermission(
        permissions,
        ROUTE_PERMISSIONS["settings/banner-management"]
      ) && (
        <SideNavLink
          href="/settings/banner-management"
          onClick={onClose}
        >
          Banner Management
        </SideNavLink>
      )}

    </SideNavMenu>

    <SideNavDivider />
  </>
)}

          {hasPagePermission(permissions,ROUTE_PERMISSIONS["settings/attributes"]) && 
          <>
          <SideNavMenu title="Attribute Management">
            <SideNavLink href="/settings/attribute-specs" onClick={onClose}>
                  Attribute Specs
                </SideNavLink>
                <SideNavLink href="/settings/attributes" onClick={onClose}>
                  Attributes
                </SideNavLink>
                
                <SideNavLink href="/settings/attribute-value" onClick={onClose}>
                  Attribute Value
                </SideNavLink>

            </SideNavMenu>
            <SideNavDivider />
          </>
          }
         {hasPagePermission(permissions,ROUTE_PERMISSIONS["settings/country"]) && 
          <>
          <SideNavMenu title="Locality Management"> 
              <SideNavLink href="/settings/country" onClick={onClose}>
                Country
              </SideNavLink>
              <SideNavLink href="/settings/state" onClick={onClose}>
                State
              </SideNavLink>

              <SideNavLink href="/settings/district" onClick={onClose}>
                District
              </SideNavLink>
              
              <SideNavLink href="/settings/taluk" onClick={onClose}>
                Taluk
              </SideNavLink>
              <SideNavLink href="/settings/village" onClick={onClose}>
                Village
              </SideNavLink>

               <SideNavLink href="/settings/area" onClick={onClose}>
                Area
              </SideNavLink>
          </SideNavMenu>
            </>
          }
{hasPagePermission(
  permissions,
  ROUTE_PERMISSIONS["settings/user"]
) && (
  <>
    {user?.role_name !== "VERIFIER" && <SideNavDivider />}

    <SideNavMenu title="User Management">

      {/* User */}
      <SideNavLink
        href="/settings/user"
        onClick={onClose}
      >
        User
      </SideNavLink>

      {/* User Subscription - Admin only / users with permission */}
      {hasPagePermission(
        permissions,
        ROUTE_PERMISSIONS["settings/user-subscription"]
      ) && (
        <SideNavLink
          href="/settings/user-subscription"
          onClick={onClose}
        >
          User Subscription
        </SideNavLink>
      )}

    </SideNavMenu>
  </>
)}
           {hasPagePermission(permissions,ROUTE_PERMISSIONS["settings/subscription"]) && 
          <>
          <SideNavDivider />
           <SideNavMenu title="Subscription Management">   
              <SideNavLink href="/settings/subscription" onClick={onClose}>
                Subscription  
              </SideNavLink>
             </SideNavMenu>
          </> }
          {hasPagePermission(permissions,ROUTE_PERMISSIONS["settings/report/location"]) && 
          <>
          <SideNavDivider />
           <SideNavMenu title="Reports">   
              <SideNavLink href="/settings/report/location" onClick={onClose}>
                Location Report
              </SideNavLink>
              <SideNavLink href="/settings/report/verification" onClick={onClose}>
                Verification Report
              </SideNavLink>
              <SideNavLink href="/settings/report/transaction" onClick={onClose}>
                Transaction Report
              </SideNavLink>
         
              <SideNavLink href="/settings/report/tags" onClick={onClose}>
                Tags Report
              </SideNavLink>
              <SideNavLink href="/settings/report/gst"onClick={onClose}>
                 GST Report
              </SideNavLink>
              <SideNavLink href="/settings/report/invoice"onClick={onClose}>
                 Invoice Report
              </SideNavLink>
                  </SideNavMenu>

                  
          </> }
          
         {hasPagePermission(
  permissions,
  ROUTE_PERMISSIONS["settings/help-desk"]
) && ( 
  <>
    <SideNavDivider />

    <SideNavMenu title="Help Desk">
      <SideNavLink
        href="/settings/help-desk/helpDesk"
        onClick={onClose}
      >
        Help Requests
      </SideNavLink>
    </SideNavMenu>
  </>
  )}






            {/* <SideNavLink href="/login" onClick={onClose}>
              </SideNavLink>
             </SideNavMenu>
          </> }






            {/* <SideNavLink href="/login" onClick={onClose}>
             Logout
            </SideNavLink> */}
        </SideNavItems>
  </SideNav>
  </div>
  );
}